import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { Divider } from '@mui/material';
import styles from "./ConfirmationModal.module.css";

interface ConfirmationModalProps {
    open: boolean,
    handleClose: React.MouseEventHandler,
    headerText: string,
    descriptionText: string,
    agreeText: string,
    disAgreeText: string,
    onAgree: React.MouseEventHandler
}

export const ConfirmationModal = ({open, handleClose, headerText, descriptionText, agreeText, disAgreeText, onAgree}: ConfirmationModalProps) => (
    <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="confirmation-dialog-title"
        aria-describedby="confirmation-dialog-description"
    >
        <DialogTitle id="confirmation-dialog-title" variant={"h2"} className={styles.confirmationDialogTitle}>
            {headerText}
        </DialogTitle>
        <DialogContent className={styles.dialogContent}>
            <DialogContentText id="confirmation-dialog-description" variant={"h6"} >
                {descriptionText}
            </DialogContentText>
        </DialogContent>
        <Divider />
        <DialogActions className={styles.dialogActions}>
            <Button onClick={handleClose} variant="outlined" color="success">
                {disAgreeText}
            </Button>
            <Button onClick={onAgree} variant="contained" color="error">
                {agreeText}
            </Button>
        </DialogActions>
    </Dialog>
);
